import _defineProperty from "@babel/runtime/helpers/defineProperty";
import styled from 'styled-components';
import { colors } from '@chegg-ui/theme';
export var StepProgress = styled.div.attrs(function (_ref) {
  var _ref2;

  var current = _ref.current,
      max = _ref.max,
      text = _ref.text;
  return _ref2 = {
    role: 'progressbar',
    value: current
  }, _defineProperty(_ref2, 'aria-valuenow', current), _defineProperty(_ref2, 'aria-valuemin', 0), _defineProperty(_ref2, 'aria-valuemax', max), _defineProperty(_ref2, 'aria-valuetext', text), _ref2;
}).withConfig({
  componentId: "sc-6b3p7i-0"
})(["display:flex;justify-content:center;align-items:center;min-height:2rem;"]);
export var StepIndicator = styled.span.withConfig({
  componentId: "sc-6b3p7i-1"
})(["display:inline-block;height:0.75rem;width:0.75rem;border-radius:50%;margin-right:0.375rem;border:1px solid ", ";background-color:", ";"], function (props) {
  return props.isActive ? colors.cheggOrange : colors.grey;
}, function (props) {
  return props.isActive ? colors.cheggOrange : 'none';
});